module.exports = __webpack_public_path__ + "img/avatar6.8fda126c.png";